import i18nFactory from '@yandex-int/i18n';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem'; // import * as i18n from ' b:components_GroupSelector t:i18n';
import { CampaignAndGroupSelectorEntityToSelectType } from '../../../typings/state';
import { Selector, SelectorItems } from '../Selector/Selector';

import * as keyset from './GroupSelector.i18n';

const i18n = i18nFactory(keyset);

export interface GroupSelectorProps {
    items?: Array<SelectorItems>;
    entitityType: CampaignAndGroupSelectorEntityToSelectType;
    onInputChange: (text: string) => void;
    onItemSelect: (selectorItems: SelectorItems) => void;
    itemSelected?: SelectorItems;
    inputText?: string;
    error?: boolean;
    isActive: boolean;
    isLoading: boolean;
}

export const GroupSelector = ({
    items,
    error,
    inputText,
    onInputChange,
    onItemSelect,
    isActive,
    itemSelected,
    isLoading,
    entitityType
}: GroupSelectorProps) => (
    <Selector
        entitityType={entitityType}
        items={items}
        cls={Bem.cls('group-selector')}
        onInputChange={onInputChange}
        onItemSelect={onItemSelect}
        placeholder={i18n('search-by-group')}
        emptyText={i18n('no-group-found')}
        awaitText={i18n('select-campaign-for-group')}
        errorText={error ? i18n('error') : ''}
        itemSelected={itemSelected}
        isLoading={isLoading}
        inputText={inputText}
        isActive={isActive}
    />
);
